import { useState } from "react";
import { FaStar, FaRegStar } from "react-icons/fa";

export default function FavoriteStar({isFavourite, onClick}) {

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={isFavourite}
      aria-label={isFavourite ? "Remove from favorites" : "Add to favorites"}
      style={{
        background: "transparent",
        border: "none",
        cursor: "pointer",
        fontSize: 22,
      }}
    >
      {isFavourite ? <FaStar color="#FFC107" /> : <FaRegStar />}
    </button>
  );
}
